import { Button } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

type PortfolioVisibilityGroupButtonProps = {
  selected: boolean;
  label: string;
  onClick: () => void;
};
export const PortfolioVisibilityGroupButton = ({
  selected,
  label,
  onClick,
}: PortfolioVisibilityGroupButtonProps) => {
  return (
    <Button
      colorScheme="aurora"
      variant={selected ? 'solid' : 'outline'}
      onClick={onClick}
      borderColor={colors.black[50]}
      fontSize="14px"
      fontWeight={500}
      padding="8px 16px"
    >
      {label}
    </Button>
  );
};
